// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"QO-z","upvoteIcon":"RO-z","downvoteIcon":"SO-z","feedbackIcon":"TO-z"};